import React from 'react';
import {
	Create,
	SimpleForm,
	DateInput,
	ReferenceInput,
	SelectInput,
	TextInput,
	NumberInput,
	required
} from 'react-admin';
import PropTypes from 'prop-types';
import { Grid } from '../../components/wrapper';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import { coreWalletFeeTypesForSelection, coreWalletFeeContextsForSelection } from './FeeDefinitionConstants';
import { coreWalletVatTypesForSelection } from '../vatDefinitions/VatDefinitionConstants';
import { countriesForSelection } from '../../i18n/en.js';
import { coreWalletTypesForSelection } from '../wallets/WalletConstants';
import { coreWalletVerificationLevelsForSelection } from '../users/UserConstants';

const subsidiaryRenderer = choice => `${choice.id}: ${choice.name}`;
const feeGroupRenderer = choice => `${choice.id}: ${choice.description}`;

const FeeDefinitionCreate = ({
	feeTypesForSelection,
	vatTypesForSelection,
	feeContextsForSelection,
	walletTypesForSelection,
	verificationLevelsForSelection,
	...props
}) => (
	<Create {...props}>
		<SimpleForm variant="standard">
			<Grid container spacing={2}>
				<Grid item xs>
					<ReferenceInput source="subsidiaryId" reference="subsidiaries" validate={required()}>
						<SelectInput optionText={subsidiaryRenderer} fullWidth />
					</ReferenceInput>
					<ReferenceInput source="feeGroupId" reference="feeGroups">
						<SelectInput optionText={feeGroupRenderer} resettable fullWidth />
					</ReferenceInput>
					<TextInput source="customType" resettable fullWidth />
					<SelectInput choices={feeTypesForSelection} source="feeType" fullWidth validate={required()} />
					<SelectInput choices={vatTypesForSelection} source="vatType" fullWidth validate={required()} />
					<SelectInput choices={feeContextsForSelection} source="feeContext" fullWidth validate={required()} />
					<SelectInput choices={countriesForSelection} source="walletCountry" resettable fullWidth />
					<SelectInput choices={walletTypesForSelection} source="walletType" resettable fullWidth />
					<SelectInput choices={verificationLevelsForSelection} source="userVerificationLevel" resettable fullWidth />
					<TextInput source="description" resettable fullWidth />
				</Grid>
				<Grid item xs>
					<ReferenceInput source="feeCurrency" reference="currencies">
						<SelectInput optionText="currencyCode" fullWidth resettable />
					</ReferenceInput>
					<NumberInput source="validFromAmount" resettable fullWidth />
					<NumberInput source="validUntilAmount" resettable fullWidth />
					<DateInput
						source="validFrom"
						fullWidth
						validate={required()}
						parse={value => toApiDateTimeFormat(value)}
						format={value => toJavaScriptDateFormat(value)}
					/>
					<DateInput
						source="validUntil"
						resettable
						fullWidth
						parse={value => toApiDateTimeFormat(value)}
						format={value => toJavaScriptDateFormat(value)}
					/>
					<NumberInput source="baseAmount" resettable fullWidth />
					<NumberInput source="minAmount" resettable fullWidth />
					<NumberInput source="maxAmount" resettable fullWidth />
					<NumberInput source="rate" resettable fullWidth />
					<NumberInput source="amountGranularity" resettable fullWidth />
					<TextInput source="paymentMethod" resettable fullWidth />
				</Grid>
			</Grid>
		</SimpleForm>
	</Create>
);

FeeDefinitionCreate.propTypes = {
	feeTypesForSelection: PropTypes.array.isRequired,
	vatTypesForSelection: PropTypes.array.isRequired,
	feeContextsForSelection: PropTypes.array.isRequired,
	walletTypesForSelection: PropTypes.array.isRequired,
	verificationLevelsForSelection: PropTypes.array.isRequired
};
FeeDefinitionCreate.defaultProps = {
	feeTypesForSelection: coreWalletFeeTypesForSelection,
	vatTypesForSelection: coreWalletVatTypesForSelection,
	feeContextsForSelection: coreWalletFeeContextsForSelection,
	walletTypesForSelection: coreWalletTypesForSelection,
	verificationLevelsForSelection: coreWalletVerificationLevelsForSelection
};

export default FeeDefinitionCreate;
